import { ApolloClient, InMemoryCache, gql, HttpLink } from "@apollo/client";

const API_URL = process.env.REACT_APP_HYGRAPH_API_URL || "";
const API_KEY = process.env.REACT_APP_HYGRAPH_API_KEY || "";

const httpLink = new HttpLink({
  uri: API_URL,
  headers: {
    Authorization: `Bearer ${API_KEY}`,
  },
});
export const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});
export const getWebProjectItems = async () => {
  const GET_ALL_PORTFOLIO_ITEMS = gql`
    query GetAllPortfolioItems($first: Int!, $skip: Int!) {
      portfolioItems(first: $first, skip: $skip, orderBy: dateCompleted_DESC) {
        id
        link
        techStack
        icon {
          url
          updatedAt
        }
        dateCompleted
        description
        title
        media {
          url
          updatedAt
        }
        important
      }
    }
  `;

  const allItems: any[] = [];
  const batchSize = 100;
  let skip = 0;
  let hasMore = true;

  while (hasMore) {
    const result = await client.query({
      query: GET_ALL_PORTFOLIO_ITEMS,
      variables: { first: batchSize, skip },
      fetchPolicy: "network-only",
    });

    const items = result.data.portfolioItems;
    allItems.push(...items);

    if (items.length < batchSize) {
      hasMore = false;
    } else {
      skip += batchSize;
    }
  }

  return allItems;
};
